/**
 * What we attach to Sentry events so an error can be traced back to a user.
 *
 * Both the web app and the crew app call this, so there is one answer to "what
 * are we allowed to send": the account id and the email, nothing else. The
 * email is the field the admin panel searches on — an id alone would mean
 * copy-pasting UUIDs to answer "did this person hit an error".
 */

export interface SentryUserContext {
  id: string;
  email?: string;
}

/**
 * Map a signed-in user to Sentry's user context, or `null` when signed out —
 * callers pass `null` straight to `Sentry.setUser`, which clears it.
 */
export function toSentryUser(
  user: { id?: string | null; email?: string | null } | null | undefined,
): SentryUserContext | null {
  if (!user?.id) return null;
  return user.email ? { id: user.id, email: user.email } : { id: user.id };
}
